module.exports = __webpack_public_path__ + "img/documents-sarah_FormServicos.3bcfe630.svg";